import { createAsyncThunk } from "@reduxjs/toolkit";
import { setErrorSnackBarMessage, setSnackBarMessage } from "../../systemSlice";
import { errorToHandler } from "../../../api/error";
import { obsRpc } from "api";
import { RootState } from "app/store";
import {
  MinioImageRegistryConfig,
  MinioObserveUpdateFields,
} from "api/observeRpcApi";

export const fetchObserveDetails = createAsyncThunk(
  "observe/fetchObserveDetails",
  async (
    {
      siteID,
      namespace,
      resourceID,
    }: { siteID: string; namespace: string; resourceID: string },
    { rejectWithValue, dispatch },
  ) => {
    return obsRpc.api
      .getObserve(siteID, namespace, resourceID)
      .then((res) => {
        return res.data;
      })
      .catch((res) => {
        dispatch(setErrorSnackBarMessage(errorToHandler(res.error)));
        return rejectWithValue(res);
      });
  },
);

export const deleteObserveInstance = createAsyncThunk(
  "observe/deleteObserveInstance",
  async (
    requestElements: { siteID: string; namespace: string; resourceID: string },
    { rejectWithValue, dispatch },
  ) => {
    return obsRpc.api
      .deleteObserve(
        requestElements.siteID,
        requestElements.namespace,
        requestElements.resourceID,
      )
      .then(() => {})
      .catch((res) => {
        dispatch(setErrorSnackBarMessage(errorToHandler(res.error)));
        return rejectWithValue(res);
      });
  },
);

export const updateObserveInstance = createAsyncThunk(
  "observe/updateObserveInstance",

  async (
    requestElements: { siteID: string; namespace: string; resourceID: string },
    { rejectWithValue, dispatch, getState },
  ) => {
    const state = getState() as RootState;
    const detailsToUpdate = state.observe.details;
    const minioCredentials = state.observe.minioCredentials;
    const imageRegistry = state.observe.imageRegistry;
    const imageRegistryUsername = state.observe.imageRegistryUsername;
    const imageRegistryPassword = state.observe.imageRegistryPassword;

    let localImageRegistryConfig: MinioImageRegistryConfig | undefined;

    if (
      imageRegistry.trim() !== "" ||
      imageRegistryUsername.trim() !== "" ||
      imageRegistryPassword.trim() !== ""
    ) {
      localImageRegistryConfig = {
        registry: imageRegistry,
        username: imageRegistryUsername,
        password: imageRegistryPassword,
      };
    }

    const newFields: MinioObserveUpdateFields = {
      volumeSize: detailsToUpdate?.volumeSize,
      storageClass: detailsToUpdate?.storageClass,
      minioUrl: detailsToUpdate?.minioUrl,
      accessKey: minioCredentials?.accesskey,
      secretKey: minioCredentials?.secretkey,
      image: detailsToUpdate?.image,
      imagePullPolicy: detailsToUpdate?.imagePullPolicy,
      imagePullSecrets: detailsToUpdate?.imagePullSecrets,
      resources: detailsToUpdate?.resources,
      env: detailsToUpdate?.env,
      ingestConfig: detailsToUpdate?.ingestConfig,
      nodeSelector: detailsToUpdate?.nodeSelector,
      tolerations: detailsToUpdate?.tolerations,
      db: detailsToUpdate?.db,
      imageRegistryConfig: localImageRegistryConfig,
    };
    if (detailsToUpdate?.tenantReference) {
      newFields.tenantReference = detailsToUpdate.tenantReference;
    }

    return obsRpc.api
      .updateObserve(
        requestElements.siteID,
        requestElements.namespace,
        requestElements.resourceID,
        {
          fields: newFields,
        },
      )
      .then(() => {
        dispatch(setSnackBarMessage("Updated Observe Instance successfully"));
        dispatch(
          fetchObserveDetails({
            siteID: requestElements.siteID,
            namespace: requestElements.namespace,
            resourceID: requestElements.resourceID,
          }),
        );
      })
      .catch((res) => {
        dispatch(setErrorSnackBarMessage(errorToHandler(res.error)));
        return rejectWithValue(res);
      });
  },
);
